declare const AutoScript

export function signString(data = '', isBase64 = false, params: any = null): Promise<string> {
  return new Promise((resolve, reject) => {
    const dataToSign = isBase64 ? data : AutoScript.getBase64FromText(data, 'default')

    AutoScript.sign(
      dataToSign,
      'SHA256withRSA',
      'CAdES',
      params,
      signatureB64 => resolve(signatureB64),
      // eslint-disable-next-line prefer-promise-reject-errors
      (errorType, errorMessage) => reject({ errorType, errorMessage })
    )
  })
}

// eslint-disable-next-line
export function signPdf(pdf, params: any = null): Promise<string> {
  return new Promise((resolve, reject) => {
    AutoScript.sign(
      pdf,
      'SHA256withRSA',
      'Adobe PDF',
      params,
      signatureB64 => resolve(signatureB64),
      // eslint-disable-next-line prefer-promise-reject-errors
      (errorType, errorMessage) => reject({ errorType, errorMessage })
    )
  })
}

// eslint-disable-next-line
export function signPades(pdf, params: any = null): Promise<string> {
  return new Promise((resolve, reject) => {
    AutoScript.sign(
      pdf,
      'SHA256withRSA',
      'PAdES',
      params,
      signatureB64 => resolve(signatureB64),
      // eslint-disable-next-line prefer-promise-reject-errors
      (errorType, errorMessage) => reject({ errorType, errorMessage })
    )
  })
}

export function startTransaction(): void {
  AutoScript.setStickySignatory(true)
}

export function endTransaction(): void {
  AutoScript.setStickySignatory(false)
}

export function getBase64FromText(text: string): string {
  return AutoScript.getBase64FromText(text)
}
